<template>
  <div id="ajuda">
    <!-- <div class="telefone">Suporte: (11) 5643-5408</div> -->
    <div class="wrapper">
      <div id="menu-mobile">
        <a href="/help/boletim" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_help_aluno.svg" alt="" />
          </div>
          <div class="label">Ajuda do Boletim</div>
        </a>

        <a href="/help/coord" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_help_coord.svg" alt="" />
          </div>
          <div class="label">Ajuda do Relatório de Coordenação</div>
        </a>
      </div>

      <div id="menu-wide">
        <a class="icon-body" href="/help/boletim">
          <div class="icon">
            <img src="@/assets/icon_help_aluno.svg" alt="" />
          </div>
          <div class="label">Ajuda do Boletim</div>
        </a>
        <a class="icon-body" href="/help/coord">
          <div class="icon">
            <img src="@/assets/icon_help_coord.svg" alt="" />
          </div>
          <div class="label">Ajuda do Relatório de Coordenação</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
#ajuda {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: center;
  flex: 1 1 auto;
  background-color: white;

  .telefone {
    display: block;
    width: 100%;
    flex: 0 0 auto;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding: 8px;
    box-sizing: border-box;
    background-color: #991f43;
    color: white;
  }

  .wrapper {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    align-content: stretch;
    justify-content: center;
    flex: 1 1 auto;
  }

  #menu-mobile {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 32px;

    .button-body {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      border-radius: 6px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      cursor: pointer;
      background-color: #e5366d;
      height: 72px;
      margin: 16px 0px;
      width: 100%;
      color: white;
      font-size: 18px;
      font-weight: 500;

      &:hover {
        background-color: #ff5b8f;
      }

      .icon {
        display: block;
        flex: 0 0 auto;
        width: 54px;
        height: 54px;
        margin: 0px 16px;
        opacity: 0.7;
      }
    }
  }

  #menu-wide {
    display: none;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    flex: 0 0 auto;
    width: 100%;
    max-width: 860px;

    .icon-body {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      align-content: center;
      justify-content: center;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      cursor: pointer;

      .icon {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        width: 230px;
        height: 230px;
        border-radius: 50%;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        background-color: #e5366d;
        margin: 5px;
        box-sizing: border-box;

        img {
          width: 180px;
          transition: inherit;
        }
      }

      .label {
        display: block;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-top: 16px;
        color: #2c2c2c;
        transition: color 0.2s ease-in-out;
        max-width: 200px;
      }

      &:hover {
        .icon {
          box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3),
            0 15px 12px rgba(0, 0, 0, 0.22);
          background-color: #ff5b8f;
          margin: 0px;
          width: 240px;
          height: 240px;

          img {
            width: 190px;
          }
        }

        .label {
          color: #607594;
        }
      }
    }
  }
}

@media only screen and (min-width: 540px) {
  #ajuda {
    #menu-mobile {
      display: none;
    }

    #menu-wide {
      display: flex;
    }
  }
}

@media only screen and (min-width: 380px) {
  #ajuda {
    #menu-mobile {
      .button-body {
        font-size: 26px;
      }
    }
  }
}
</style>
